import { useEffect } from 'react';
// Mui
import { Box, Container } from '@mui/material';
// Components
import CasesProvider from './providers/CasesProvider';
// 
import CasesToolbar from './CasesToolbar';
import CasesFilter from './CasesFilter';
import CasesList from './CasesList';
import CasesFab from './CasesFab';
// 
import Mixpanel from 'app/services/Mixpanel.service';
import MixpanelTracks from 'app/types/MixpanelTracks';

const CasesPage = () => {
  useEffect(() => {
    Mixpanel.track(MixpanelTracks.CaseListView);
    // eslint-disable-next-line
  }, []);

  return (
    <CasesProvider>
      <CasesToolbar />
      <Box sx={{ flexGrow: 1, overflowY: 'auto' }} react-action="scroll">
        <Container sx={{ pt: 4, pb: 16 }} maxWidth="md" >
          <CasesFilter />
          <CasesList />
        </Container>
      </Box>
      <CasesFab />
    </CasesProvider>
  )
}

export default CasesPage;
